import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "form", "input"]

  connect() {
    this.boundHide = this.hideIfOutside.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.boundHide)
  }

  edit(event) {
    event.preventDefault()
    this.displayTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
    document.addEventListener("click", this.boundHide)

    requestAnimationFrame(() => {
      this.inputTarget.focus()
      this.inputTarget.select()
    })
  }

  submit() {
    this.formTarget.requestSubmit()
  }

  cancel(event) {
    event.preventDefault()
    this.hideForm()
  }

  hideIfOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideForm()
    }
  }

  hideForm() {
    document.removeEventListener("click", this.boundHide)
    this.formTarget.classList.add("hidden")
    this.displayTarget.classList.remove("hidden")
  }
}
